import { graphql, useStaticQuery } from "gatsby";
export const NewsData = () => {
  const newsPosts = useStaticQuery(graphql`
    query NewsPostQuery {
      wp:allWpPost(
        filter: {categories: {nodes: {elemMatch: {slug: {eq: "news"}}}}}
        limit: 4
        sort: {date: DESC}
      ) {
        nodes {
          title
          uri
          excerpt
          date(formatString: "DD/MM/YYYY")
          author {
            node {
              name
            }
          }
          feat:featuredImage {
            node {
              img:gatsbyImage(width: 600)
            }
          }
        }
      }
    }
  `)
  if (newsPosts.wp?.nodes) return newsPosts
  else return
} 